import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Allocation, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editAllocation(request: Boundaries["editAllocation"]["request"]): void;
}

function useEditAllocation(allocation: Identifiable<Allocation>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditAllocationRequestPending(allocation),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditAllocationRequestSuccess(allocation),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditAllocationRequestFailure(allocation),
    ),
    editAllocation: core.editAllocation,
  };
}

export { useEditAllocation };
